"use client";
import { useEffect } from "react";

import { useStore, observer } from "../../service/mobx";
import { useTrackView } from "../../component/Hooks";

function Hooks() {
  useTrackView("Model");
}
export default observer(Hooks);
export function HooksClient({ node, readme, json, related }) {
  const { model } = useStore();

  useEffect(() => {
    model.set.node(node);
    model.set.readme(readme);
    model.set.json(json);
    model.set.related(related);
    // set context
    return model.reset;
  }, [model, node, readme, json, related]);
}
